import { render, staticRenderFns } from "./RsaConfigurazioneLaboratoriRepartiEditModalComponent.vue?vue&type=template&id=651c03ce"
import script from "./RsaConfigurazioneLaboratoriRepartiEditModalComponent.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneLaboratoriRepartiEditModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports